import React from 'react'
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import Pagination from '../../../components/base/Pagination';
import BiltiSlipUploader from './BiltiSlipUploader';

function ChallansTable({ getFilteredChallans, handleEdit, handleStatusUpdate, handlePrint, handleDelete,
    challanCurrantPage,
    setChallanCurrantPage,
    permiton,
    challanPage, }) {
    return (
        <Card className="overflow-hidden">
            <div className="overflow-x-auto max-h-[600px]">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Challan Details
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Client & Order
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Value & Pieces
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status & Vendor
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Bilti Slip
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {getFilteredChallans().map((challan) => {
                            const totalPcs = challan.items.reduce((sum, item) => sum + (item.dispatchedQty * item.pcsInSet), 0);

                            return (
                                <tr key={challan.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-4">
                                        <div>
                                            <div className="text-sm font-medium text-gray-900">{challan.challanNumber}</div>
                                            <div className="text-sm text-gray-500">{challan.date}</div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div>
                                            <div className="text-sm font-medium text-gray-900">{challan.customer}</div>
                                            <div className="text-sm text-gray-500">Order: {challan.orderNumber}</div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div>
                                            <div className="text-sm font-medium text-gray-900">₹{challan.totalValue.toLocaleString()}</div>
                                            <div className="text-sm text-blue-600">{totalPcs} pcs dispatched</div>
                                            <div className="text-sm text-gray-500">{challan.items.length} item{challan.items.length > 1 ? 's' : ''}</div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div>
                                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${challan.status === 'Dispatched' ? 'bg-green-100 text-green-800' :
                                                challan.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                                    'bg-gray-300 text-gray-800'
                                                }`}>
                                                {challan?.status}
                                            </span>
                                            <div className="text-sm text-gray-500 mt-1">{challan.vendor}</div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div>
                                            <BiltiSlipUploader challan={challan} permiton={permiton} />
                                        </div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                        <div className="flex flex-col space-y-1">
                                            {permiton.update && <div className="flex space-x-1">
                                                <Button
                                                    onClick={() => handleEdit(challan, 'challan')}
                                                    className="bg-blue-950 text-blue-600 hover:bg-blue-100 text-xs px-2 py-1"
                                                >
                                                    <i className="ri-edit-line mr-1"></i>Edit
                                                </Button>
                                                {/* <div className="relative group">
                                                    <Button className="bg-purple-750 text-purple-600 hover:bg-blue-700 text-xs px-2 py-1">
                                                        <i className="ri-arrow-down-s-line"></i>Status
                                                    </Button>
                                                    <div className="absolute right-0 mt-1 w-32 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
                                                        <div className="py-1">
                                                            <button
                                                                onClick={() => handleStatusUpdate(challan?._id, 'Pending', 'challan')}
                                                                className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-100 w-full text-left"
                                                            >
                                                                Pending
                                                            </button>
                                                            <button
                                                                onClick={() => handleStatusUpdate(challan?._id, 'Dispatched', 'challan')}
                                                                className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-100 w-full text-left"
                                                            >
                                                                Dispatched
                                                            </button>
                                                            <button
                                                                onClick={() => handleStatusUpdate(challan?._id, 'Completed', 'challan')}
                                                                className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-100 w-full text-left"
                                                            >
                                                                Completed
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>}
                                            <div className="flex space-x-1">
                                                <Button
                                                    onClick={() => handlePrint(challan, 'challan')}
                                                    className="bg-green-500 text-green-600 hover:bg-green-900 text-xs px-2 py-1"
                                                >
                                                    <i className="ri-printer-line mr-1"></i>Print
                                                </Button>
                                                {permiton.delete && <Button
                                                    onClick={() => handleDelete(challan?._id, 'challan')}
                                                    className="bg-red-500 text-red-600 hover:bg-red-900 text-xs px-2 py-1"
                                                >
                                                    <i className="ri-delete-bin-line mr-1"></i>Delete
                                                </Button>}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="flex justify-center mt-4">
                {/* <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                /> */}

                {challanPage > 1 && (
                    <div className="flex justify-center mt-6">
                        <div className="flex space-x-2">
                            <Button
                                onClick={() => setChallanCurrantPage(prev => Math.max(prev - 1, 1))}
                                disabled={challanCurrantPage === 1}
                                className="px-4 py-2 bg-gray-100 text-gray-700 disabled:opacity-50"
                            >
                                Previous
                            </Button>

                            {Array.from({ length: challanPage }, (_, i) => i + 1).map(page => (
                                <Button
                                    key={page}
                                    onClick={() => setChallanCurrantPage(page)}
                                    className={`px-4 py-2 ${challanCurrantPage === page
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700'}`}
                                >
                                    {page}
                                </Button>
                            ))}

                            <Button
                                onClick={() => setChallanCurrantPage(prev => Math.min(prev + 1, challanPage))}
                                disabled={challanCurrantPage === challanPage}
                                className="px-4 py-2 bg-gray-100 text-gray-700 disabled:opacity-50"
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )}

            </div>

        </Card>
    )
}

export default ChallansTable
